<svg
	class="flex-shrink-0"
	width="18"
	height="19"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	on:click
	><path
		d="M15 7.25H8.25a1.5 1.5 0 0 0-1.5 1.5v6.75a1.5 1.5 0 0 0 1.5 1.5H15a1.5 1.5 0 0 0 1.5-1.5V8.75a1.5 1.5 0 0 0-1.5-1.5Z"
		stroke="#6C757D"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/><path
		d="M3.75 11.75H3a1.5 1.5 0 0 1-1.5-1.5V3.5A1.5 1.5 0 0 1 3 2h6.75a1.5 1.5 0 0 1 1.5 1.5v.75"
		stroke="#6C757D"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/></svg
>
